import { Injectable } from '@angular/core';

import { DPLConstraintGroup } from '../models/need4steel';

@Injectable({ providedIn: 'root' })
export class Need4SteelHelperService {
	setProperty<T, K extends keyof T>(obj: T, key: K, value: T[K]) {
		obj[key] = value;
		return obj;
	}

	settingGroupHasCodeValuesPair(
		group: DPLConstraintGroup,
		code1: string,
		code2: string,
		value1: number,
		value2: number
	) {
		const correspondingThicknessInGroup = group.settings
			.filter(v => v.fieldName.toLowerCase() === code1
				&& ((v.minValueExcluded && v.minValue < value1) || (!v.minValueExcluded && v.minValue <= value1))
				&& ((v.maxValueExcluded && value1 < v.maxValue) || (!v.maxValueExcluded && value1 <= v.maxValue)));
		const correspondingWidthInGroup = group.settings
			.filter(v => v.fieldName.toLowerCase() === code2
				&& ((v.minValueExcluded && v.minValue < value2) || (!v.minValueExcluded && v.minValue <= value2))
				&& ((v.maxValueExcluded && value2 < v.maxValue) || (!v.maxValueExcluded && value2 <= v.maxValue)));
		return correspondingThicknessInGroup.length > 0 && correspondingWidthInGroup.length > 0;
	}
}
